// extracted by mini-css-extract-plugin
export default {"panel":"ChoicePanel_panel__wmU0f","animationDrag":"ChoicePanel_animationDrag__ukNpb","panel-extended":"ChoicePanel_panel-extended__tb4yZ"};